<template>
  <div>
    <div
      class="media-image-viewer-layout__background"
      :style="{ backgroundImage: `url('${imageUrl}')` }"
    />
    <img
      :src="imageUrl"
      class="media-image-viewer-layout__image"
      data-test-id="MediaImageViewerLayout_Image"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
  },
})
</script>

<style lang="postcss">
.media-image-viewer-layout {
  &__image {
    position: relative;
    z-index: 1;
    left: 50%;
    max-width: 100%;
    max-height: 50vh;
    transform: translateX(-50%);
  }

  &__background {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
    opacity: 0.1;
    pointer-events: none;
  }
}
</style>
